import React from "react";
import { parseCMSBold } from "@app/Helpers.js";
import { Link } from "react-router-dom";
import BrandLogo from "@components/BrandLogo";
import { parseDate } from "../../Helpers";
import ExpiredIcon from "./img/expired-icon.svg?react";
import "./style.scss";
import DOMPurify from "dompurify";

function Expires({ expires, disabled }) {
  if (disabled) {
    return (
      <div className="flex-wrapper">
        <p className="expired">Abgelaufener Gutschein</p>
        <ExpiredIcon />
      </div>
    );
  }

  return (
    <p className="expires">
      Gültigkeitsdatum: <span>{parseDate(expires)}</span>
    </p>
  );
}

export default function ReceivedAwardCard({
  content,
  expires,
  disabled,
  imgDesc,
  brands,
  className = "",
  mobileImg,
  uuid,
}) {
  const determineLink = () => {
    return `/coupons/received/${uuid}`;
  };

  return (
    <div
      className={`received-award-card-component ${disabled ? "disabled" : ""} ${
        className ? className : ""
      }`}
    >
      <Link to={determineLink()}>
        <div className="inner">
          <div className="img-wrapper">
            <picture>
              <source />
              <img src={mobileImg} alt={imgDesc} />
            </picture>
          </div>

          <BrandLogo brands={brands} />

          <div className="award-info">
            <p
              className="copy"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(parseCMSBold(content?.title))}}
            />
            <hr />
            <Expires expires={expires} disabled={disabled} />
          </div>
        </div>
      </Link>
    </div>
  );
}
